import React, { Component } from "react";
import Header from "../../components/header/Header";
import ManualProjectCard from "../../components/ManualProjectCard/ManualProjectCard"; 
import Button from "../../components/button/Button";
import TopButton from "../../components/topButton/TopButton";
import { Fade } from "react-reveal";
import { projectsHeader } from "../../portfolio.js";
import ProjectsData from "../../shared/opensource/projects.json"; 
import "./Projects.css";
import ProjectsImg from "./ProjectsImg";

import ModalVideo from "react-modal-video";
import "react-modal-video/scss/modal-video.scss";

class Projects extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isOpen: false,
      videoId: null,
    };
  }

  openModal = (url) => {
    if (url && url !== "#") {
      try {
        // Handle both full URLs and short YouTube IDs
        if (url.includes("youtube.com") || url.includes("youtu.be")) {
          const urlObj = new URL(url);
          const id = url.includes("youtu.be") 
            ? url.split("/").pop().split("?")[0]
            : urlObj.searchParams.get("v");
          if (id) this.setState({ videoId: id, isOpen: true });
        } else {
          // Assume it's a YouTube ID
          this.setState({ videoId: url, isOpen: true });
        }
      } catch (error) {
        console.error("Invalid URL:", error);
      }
    }
  };

  render() {
    const theme = this.props.theme;
    return (
      <div className="projects-main">
        <Header theme={theme} />

        <ModalVideo
          channel="youtube"
          isOpen={this.state.isOpen}
          videoId={this.state.videoId}
          onClose={() => this.setState({ isOpen: false })}
        />

        <div className="basic-projects">
          <Fade bottom duration={2000} distance="40px">
            <div className="projects-heading-div">
              <div className="projects-heading-text-div">
                <h1
                  className="projects-heading-text"
                  style={{ color: theme.text }}
                >
                  {projectsHeader.title}
                </h1>
                <p
                  className="projects-header-detail-text subTitle"
                  style={{ color: theme.secondaryText }}
                >
                  {projectsHeader.description}
                </p>
              </div>
            </div>
          </Fade>
        </div>

        <div className="repo-cards-div-pad">
          <div className="repo-cards-div-main">
            {ProjectsData.data.map((project) => (
              <ManualProjectCard
                key={project.id}
                project={project}
                theme={theme}
                onVideoClick={this.openModal}
              />
            ))}
          </div>
        </div>

        <Button
          text="More Projects"
          className="project-button"
          href="https://www.github.com/zxkings/"
          newTab={true}
          theme={theme}
        />
        
        <TopButton theme={theme} />
      </div>
    );
  }
}

export default Projects;